import * as React from "react";

import { Control, Errors } from "react-redux-form";
import {
    mapProps,
    showErrors,
    updateOn,
    validateOn
} from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import DateTimeComponent from "./DateTimeComponent";

interface DateTimeControlProps {
    mandatory: boolean;
    model: string;
    dateTitle: string;
    timeTitle: string;
    readOnly?: boolean;
    viewMode?: string;
    validate?: any;
    valid?: any;
    touched?: any;
}

class DateTimeControl extends React.PureComponent<DateTimeControlProps, any> {
    render() {

        // NOTE: [IACPLAT-70] do not change this dateformat/timeformat 
        // without also changing how it is parsed on the server
        const dateFormat = "M/D/YYYY";
        const timeFormat = "hh:mm:ss A Z";
        
        return (
            <>
                <Control
                    model={this.props.model}
                    validators={{
                        //required: this.props.mandatory ? requiredDate : () => true
                    }}
                    component={DateTimeComponent}
                    updateOn={updateOn}
                    validateOn={validateOn}
                    mapProps={mapProps}
                    controlProps={{
                        dateFormat: dateFormat,
                        timeFormat: timeFormat,
                        dateTitle: this.props.dateTitle,
                        timeTitle: this.props.timeTitle,
                        dateTextBox: false,
                        timeTextBox: false,
                    }}
                    readOnly={this.props.readOnly}
                />
                <Errors
                    model={this.props.model}
                    messages={{
                        required: "Please select a date"
                    }}
                    className="invalid-feedback d-block"
                    show={showErrors}
                    component={ValidationMessage}
                />
            </>
        );
    }
}

export default DateTimeControl;
